import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DataTableParams } from 'angular-datatables-all-versions';
import { ApiService } from './api.service';
import { Subscription} from '../models/subscription.model';

@Injectable()
export class SubscriptionService {

  constructor(private apiService: ApiService) { }

  list(params: DataTableParams): Observable<any> {
    params.offset = params.offset / params.limit;
    return this.apiService.post('gandadmin/subscriptions', params);
  }

  update(subscription: Subscription): Observable<any> {
    return this.apiService.post('gandadmin/subscriptions/' + subscription.id, { charity_subscription: subscription });
  }
}
